module.exports = __webpack_public_path__ + "97dbb56dbbcf6b9e655d1b61e9528700.svg";